import { CSSProperties, FC } from 'react';
import { motion } from 'framer-motion';

import { mainButtonContainer, mainButtonStyle } from './styles.ts';

import loadingAnimationData from '@/components/common/svg/assets/loader_rounded.json';
import LottieAnimation from '@/animations/LottieAnimation.tsx';
import UIConfig from '@/UIConfig.ts';

interface MainButtonProps {
  onClick: () => void;
  loading?: boolean;
  text?: string | JSX.Element;
  fixed?: boolean;
  containerStyle?: CSSProperties;
  buttonStyle?: CSSProperties;
  disabled?: boolean;
}

export const MainButton: FC<MainButtonProps> = ({
  onClick,
  text = 'Save',
  fixed,
  containerStyle,
  buttonStyle,
  disabled,
  loading
}) => (
  <div style={{ ...mainButtonContainer(fixed), ...containerStyle }}>
    <motion.div
      whileTap={!disabled ? { scale: 0.9 } : {}}
      style={{
        ...mainButtonStyle,
        cursor: !disabled ? 'pointer' : 'not-allowed',
        opacity: loading ? 0.5 : 1,
        background: disabled ? '#d3d3d3' : UIConfig.Colors.BackgroundDark,
        color: '#fff',
        ...buttonStyle
      }}
      onClick={!disabled ? onClick : undefined}
    >
      {loading ? (
        <LottieAnimation
          width={40}
          height={40}
          animationData={loadingAnimationData}
          shouldAnimate={true}
          loop={true}
          color="#fff"
        />
      ) : (
        <span style={{ fontSize: '17px' }}>{text}</span>
      )}
    </motion.div>
  </div>
);
